module.exports = __webpack_public_path__ + "img/Kelly.6fbf427.png";